import { leftArrowIcon } from "../../../assets/svgs/icons/icons.svg";
import FooterBackGroundImage from "../../../assets/png/error-page-decoration.png";
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import styles from "./PageNotFound.module.scss";

export default function PageNotFound() {
  const { t } = useTranslation();
  
  return (
    <article className={styles.pageNotFound}>
      <main className={styles.pageNotFound__box}>
        <h1>{t('error.pageNotFound')}</h1>
        <p>
          {t('error.pageNotFoundDesc')}
        </p>
        <Link to="/">
          {leftArrowIcon} {t('error.returnToHome')}
        </Link>
      </main>
      <footer
        className={styles.pageNotFound__footer}
        style={{ backgroundImage: `url(${FooterBackGroundImage})` }}
      ></footer>
    </article>
  );
}
